import { NgModule } from '@angular/core';
import { CheckPermissionsDirective } from '@shared/directives/check-permissions/check-permissions.directive';

@NgModule({
  declarations: [CheckPermissionsDirective],
  imports: [],
  exports: [CheckPermissionsDirective],
})
export class CheckPermissionsModule {}
